// arabic speaking storefront
export const ARABIC_SF = [
    'dz', // Algeria
    'bh', // Bahrain,
    'eg', // Egypt,
    'iq', // Iraq,
    'jo', // Jordan,
    'kw', // Kuwait,
    'lb', // Lebanon,
    'ly', // Libya,
    'mr', // Mauritania,
    'ma', // Morocco,
    'om', // Oman,
    'qa', // Qatar,
    'sa', // Saudi Arabia,
    'tn', // Tunisia,
    'ae', // United Arab Emirates,
    'ye', // Yemen,
];

// greek speaking storefront, Greece and Cyprus
export const EL_SF = ['gr', 'cy'];
